import {
  Toolbar,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import "./sidebar.css";

import { SlidebarDataAdmin } from "../SlidebarDataAdmin";
import { SlidebarDataCliente } from "../SlidebarDataCliente";
import { SlidebarDataOperario1 } from "../SlidebarDataOperario1";
import { SlidebarDataOperario2 } from "../SlidebarDataOperario2";
import { useContext, useEffect, useState } from "react";
import { getParametrosAnalisisPlanta } from "../../api";
import { AuthContext } from "../../context/AuthContext";
import { Box } from "@mui/system";

import { useOnlineStatus } from "../../hooks/useSync";

export const SidebarContent = ({ abrirCerrar, abierto }) => {
  // Importamos el hook de navegación para cambiar entre páginas
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [tareas, setTareas] = useState([]);
  const { user } = useContext(AuthContext);
  const isOnline = useOnlineStatus();

  const peticionTareasPendientes = async () => {
    const today = new Date(); // Obtén la fecha actual
    const filteredTasks = tareas.filter(
      (tarea) => new Date(tarea.fecha) <= today,
    );
    setRows(filteredTasks);
  };

  useEffect(() => {
    getParametrosAnalisisPlanta().then((resp) => {
      setTareas(
        resp.filter(
          (tarea) =>
            tarea.operario === user.id && !tarea.realizado && !tarea.deleted,
        ),
      );
    });
  }, [user.id]);

  useEffect(() => {
    peticionTareasPendientes();
  }, [tareas]);

  return (
    <>
      <Toolbar disableGutters>
        {user.activo && (
          <div
            className={
              abierto
                ? "logo-container-cabecera-abierto"
                : "logo-container-cabecera-cerrado"
            }
            onClick={abrirCerrar}
          >
            <div
              style={{
                position: "relative",
                width: 40,
                height: 40,
                marginRight: 16,
              }}
            >
              <Avatar
                alt="Logo JNegre"
                src="/img/logo.svg"
                sx={{ width: 40, height: 40 }}
              />
              <span
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: 15,
                  height: 15,
                  borderRadius: "50%",
                  backgroundColor: isOnline ? "#22c55e" : "#ef4444",
                  border: "2px solid white",
                  zIndex: 10,
                  display: "block",
                }}
              ></span>
            </div>

            {abierto && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                  {user.nombre}
                </Typography>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: isOnline ? "#22c55e" : "#ef4444",
                  }}
                >
                  ● {isOnline ? "Online" : "Offline"}
                </span>
              </div>
            )}
          </div>
        )}
      </Toolbar>
      <Divider />
      {user.idPerfil === 1 || user.idPerfil === 1005 ? (
        <List className="list-contenedor-sidebar">
          {SlidebarDataAdmin.filter(
            (item) => !item.onlyFor || item.onlyFor === user.id,
          ) // 👈 FILTRADO
            .map(({ key, title, path, icon }) => (
              <ListItem key={key} disablePadding>
                <ListItemButton
                  onClick={() => navigate(path, { replace: false })}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  {abierto && <ListItemText primary={title} />}
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      ) : (
        false
      )}
      {user.idPerfil === 1004 && rows.length > 0 ? (
        <List className="list-contenedor-sidebar">
          {
            // Recorremos todos los elementos del array para crear las opciones del menú
            SlidebarDataOperario1.map(({ key, title, path, icon }) => (
              <ListItem key={key} disablePadding>
                <ListItemButton
                  onClick={() => navigate(path, { replace: false })}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  {abierto && <ListItemText primary={title} />}
                </ListItemButton>
              </ListItem>
            ))
          }
        </List>
      ) : (
        false
      )}
      {user.idPerfil === 1004 && rows.length === 0 ? (
        <List className="list-contenedor-sidebar">
          {
            // Recorremos todos los elementos del array para crear las opciones del menú
            SlidebarDataOperario2.map(({ key, title, path, icon }) => (
              <ListItem key={key} disablePadding>
                <ListItemButton
                  onClick={() => navigate(path, { replace: false })}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  {abierto && <ListItemText primary={title} />}
                </ListItemButton>
              </ListItem>
            ))
          }
        </List>
      ) : (
        false
      )}
      {user.idPerfil === 4 ? (
        <List className="list-contenedor-sidebar">
          {
            // Recorremos todos los elementos del array para crear las opciones del menú
            SlidebarDataCliente.map(({ key, title, path, icon }) => (
              <ListItem key={key} disablePadding>
                <ListItemButton
                  onClick={() => navigate(path, { replace: false })}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText primary={title} />
                </ListItemButton>
              </ListItem>
            ))
          }
        </List>
      ) : (
        false
      )}

      {/* Versión al final del sidebar */}
      <Box
        sx={{
          marginTop: "auto",
          padding: 0.5,
          textAlign: "center",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: "0.75rem" }}
        >
          {abierto ? "J. Negre C. · v9.1.2" : "v9.1.2"}
        </Typography>   
      </Box>
    </>
  );
};
